import {useTheme, css, Typography} from '@mui/material';
import {
  DlMuiPopper,
  GetStylesFunction,
  mixins,
  useMuiAnchor,
  utils,
} from '@wallaby-ui/core';
import * as React from 'react';
import {useIntl} from 'react-intl';
import {WallabyCoreSchema} from 'src/js/common/types';
import {TemplatedCellRendererParams} from 'src/js/containers/grid';

type Props = TemplatedCellRendererParams<
  WallabyCoreSchema.components['schemas']['DocumentForEncounterDto']
>;

export const DocumentsListDepartmentFormatter: React.FC<Props> = (props) => {
  const {data} = props;
  const untranslatedTitle = data?.organizationLongName;
  const hasTooltip = !!untranslatedTitle;

  const {mouseEventEnter, mouseEventLeave, open, anchorEl} =
    useMuiAnchor(hasTooltip);
  const theme = useTheme();
  const intl = useIntl();
  const styles = getStyles({theme});
  const translatedLabel =
    intl && utils.TranslateUtils.translate(data?.organizationShortName, intl);
  const translatedTitle =
    intl && utils.TranslateUtils.translate(untranslatedTitle, intl);

  return data ? (
    <div css={styles.wrapper}>
      <Typography
        variant={'valueBold'}
        css={styles.span}
        onMouseEnter={mouseEventEnter}
        onMouseLeave={mouseEventLeave}
      >
        {translatedLabel}
      </Typography>
      <DlMuiPopper hasTooltip={hasTooltip} anchorEl={anchorEl} open={open}>
        <Typography variant={'popper'}>{translatedTitle}</Typography>
      </DlMuiPopper>
    </div>
  ) : null;
};

DocumentsListDepartmentFormatter.displayName =
  'DocumentsListDepartmentFormatter';

const getStyles: GetStylesFunction = (options) => ({
  span: css`
    padding: ${options?.theme?.spacing(1, 0)};
  `,
  wrapper: css`
    ${mixins.dlTextOverflowEllipses};
    min-width: 0;
  `,
});
